import React from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import ShopCardDumb from '../_partials/ShopCardDumb';
import Stats from '../../Stats';
import DeviationLink from '../../Duperbrowse/DeviationLink';
import DeviationThumbIndicators from '../../DeviationViews/Thumb/legos/DeviationThumbIndicators';
import { getDeviationPrice } from '../helpers';
import PriceWithPoints from '../_partials/PriceWithPoints';
import { formatDollars } from '../../utils/formatting';
import s from './DeviationShopCard.scss';
const DeviationShopCard = ({ deviation, width, withAuthorDetails, withIndicators = true, withStats, withDescriptionBlock, detailsRightSlot, belowCoverImageRightSlot, noCentsOnPrice })=>{
    const { dollarsPrice, pointsPrice } = getDeviationPrice(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(DeviationLink, {
        className: s['link'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(ShopCardDumb, {
        width: width,
        coverImage: deviation,
        title: deviation.title,
        withAuthorDetails: withAuthorDetails,
        author: deviation.author,
        withDescriptionBlock: withDescriptionBlock,
        description: deviation.textContent,
        indicatorsSlot: withIndicators && /*#__PURE__*/ React.createElement(DeviationThumbIndicators, {
            className: s['indicators'],
            deviation: deviation
        }),
        belowCoverImageSlot: withStats && /*#__PURE__*/ React.createElement(Flex, {
            justifyContent: "space-between"
        }, /*#__PURE__*/ React.createElement(Stats, {
            deviation: deviation,
            withViewCount: false,
            withBadges: false,
            withCommentControl: false,
            withSubscriberCount: false,
            withUserList: false,
            withDaProtectIndicator: false,
            withNoAiIndicator: false,
            onlyNumbers: true
        }), belowCoverImageRightSlot),
        detailsRightSlot: detailsRightSlot || /*#__PURE__*/ React.createElement(PriceWithPoints, {
            formattedDollarsPrice: noCentsOnPrice ? `$${parseInt(dollarsPrice)}` : formatDollars(dollarsPrice),
            pointsPrice: pointsPrice
        })
    }));
};
DeviationShopCard.displayName = 'DeviationShopCard';
export default DeviationShopCard;
